/* eslint-disable */
import HttpService from '../HttpService';
export default class ContractService {
    constructor() {
      this._httpService = new HttpService('/contract/contract');
      this._movementDeadlineHttpService = new HttpService('/contract/movement-deadlines-operation');
      this._odooService = new HttpService('/odoo');
    }

    async FindAllByFilters(params) {
      return await this._httpService.get(`/all?verifyPermission=true&${params}&onlyMainFields=true`);
    }

    async FindByIds(ids) {
      return await this._httpService.get(`/findByIds?ids=${ids}`);
    }

    async FindAllContractsByCarrierId(carrierId) {
      return await this._httpService.get(`/all?verifyPermission=false&carrierId=${carrierId}&subcontract=false&onlyMainFields=true`);
    }

    async FindAll() {
    return await this._httpService.get(`/all?verifyPermission=true&onlyMainFields=true`);
    }

    async FindById(contractId) {
      return await this._httpService.get(`/migration/${contractId}?onlyMainFields=true`);
    }

    async FindByParentId(parentId) {
      return await this._httpService.get(`/subcontracts/${parentId}?onlyMainFields=true`);
    }

    async FindByParentIdByFilters(parentId, params) {
      const path = "/subcontracts";
      const queryParameters = params ? `?${params}&onlyMainFields=true`: '?onlyMainFields=true';
      const url = `${path}/${parentId}${queryParameters}`;
      return await this._httpService.get(url);
    }

    async ValidateGracePeriod(params) {
      return await this._httpService.post(`/validate-grace-period`, params);
    }

    async FindActiveContractPlanCoverage(contractId, planId) {
      return await this._odooService.get(`/contract-coverage?contractId=${contractId}&planId=${planId}&active=true`)
    }

    async FindMovementDeadlineOperationsByContractId(contractId) {
      return await this._movementDeadlineHttpService.get(`?contractId=${contractId}`);
    }
 };
